module.exports = __webpack_public_path__ + "static/img/co6.e6619af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/co6.jpg
// module id = 2rDW
// module chunks = 11